import {
  RatingConfigurator,
  CommentConfigurator,
  EmailConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const escWebuiUserSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'EscWebuiUserSurvey',
    style: {
      root: {
        maxWidth: 480,
      },
    },
    others: {
      combineTextInputToComment: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with Microsoft Advertising\'s web user interface?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neither satisfied nor dissatisfied')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      isRequired: false,
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 1,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes')),
          hasInput: false,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
          hasInput: false,
        },
      ],
    },
    questions: [
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q3',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('How can we continue to improve?')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
      },
    ],
  };
};
